import React from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { Row, Card, ProgressBar } from "@masterteam/mt-design-react";

import DoughnutChart from "../../DoughnutChart";
import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

const ObjectiveCard = ({ data, statuses, isAttribute = false }) => {
  const [isAr] = useIsAr();
  const intl = useIntl();
  const history = useHistory();
  const status = statuses.find((e) => e.Code === data.Status);

  return (
    <Card
      gap={16}
      direction="vertical"
      className={`objective-card-wrapper ${!isAttribute && "cursor"}`}
      onClick={() => {
        if (!isAttribute)
          history.push(`/splus/kpis-dashboard/objective-details/${data.ID}`);
      }}
    >
      <div className="card-title">
        <p> {isAr ? data?.ArabicName : data?.EnglishName}</p>
      </div>

      <Row className="progress" gap="5px">
        <ProgressBar value={data?.Performance} color={status.Color} />
        <span style={{ color: status?.Color }}>{data?.Performance} %</span>
      </Row>

      <Row
        size="large"
        className="doughnutCharts"
        justify={isAttribute ? "center" : "between"}
      >
        <div className="doughnutChartWrapper">
          <DoughnutChart
            data={data?.KPIByStatuses || []}
            statuses={statuses}
            count={data?.KPICount}
            title={intl.formatMessage({ id: "common.kpis" })}
          />
        </div>

        {!isAttribute && (
          <div className="doughnutChartWrapper">
            <DoughnutChart
              data={data?.AttributeByStatuses || []}
              statuses={statuses}
              count={data?.AttributeCount}
              title={intl.formatMessage({
                id: "common.sub-strategic-objectives",
              })}
            />
          </div>
        )}
      </Row>
    </Card>
  );
};

export default ObjectiveCard;
